const CompetitorIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 2H3.33333C2.59695 2 2 2.59695 2 3.33333V6C2 6.73638 2.59695 7.33333 3.33333 7.33333H6C6.73638 7.33333 7.33333 6.73638 7.33333 6V3.33333C7.33333 2.59695 6.73638 2 6 2Z"
        stroke="#0A0A0A"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.6665 7.33594V10.0026C4.6665 10.3562 4.80698 10.6954 5.05703 10.9454C5.30708 11.1955 5.64622 11.3359 5.99984 11.3359H8.6665"
        stroke="#0A0A0A"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6665 8.66406H9.99984C9.26346 8.66406 8.6665 9.26102 8.6665 9.9974V12.6641C8.6665 13.4004 9.26346 13.9974 9.99984 13.9974H12.6665C13.4029 13.9974 13.9998 13.4004 13.9998 12.6641V9.9974C13.9998 9.26102 13.4029 8.66406 12.6665 8.66406Z"
        stroke="#0A0A0A"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CompetitorIcon;
